<template>
  <div :class="$style.container">
    <div :class="$style.title">{{ $t("solutionSection.title") }}</div>
    <div :class="$style.description">
      {{ $t("solutionSection.description") }}
    </div>
    <div :class="$style.schoolGardensBlock">
      <SchoolGardensSlider
        :class="$style.gallery"
        :images="schoolGardenImages"
        :alt-prefix="$t('solutionSection.schoolGardens.title')"
      />
      <div :class="$style.featureText">
        <div :class="$style.subtitle">
          {{ $t("solutionSection.schoolGardens.title") }}
        </div>
        <div :class="$style.text">
          <p>{{ $t("solutionSection.schoolGardens.firstText") }}</p>
          <p>{{ $t("solutionSection.schoolGardens.secondText") }}</p>
        </div>
        <button :class="$style.button" @click="openSchoolGardensPage">
          {{ $t("solutionSection.schoolGardens.learnMore") }}
        </button>
      </div>
      <Applicate :class="$style.applicate" />
    </div>
    <div :class="[$style.schoolGardensBlock, $style.reverse]">
      <div :class="$style.featureText">
        <div :class="$style.subtitle">
          {{ $t("solutionSection.educationalPartners.title") }}
        </div>
        <div :class="$style.text">
          <p>{{ $t("solutionSection.educationalPartners.firstText") }}</p>
          <p>{{ $t("solutionSection.educationalPartners.secondText") }}</p>
        </div>
        <button :class="$style.button" @click="openEducationalPartnersPage">
          {{ $t("solutionSection.educationalPartners.learnMore") }}
        </button>
      </div>
      <div :class="$style.image">
        <img
          src="/images/work/img-edu_partners.jpg"
          :alt="$t('solutionSection.educationalPartners.title')"
        />
      </div>
    </div>
    <div :class="$style.schoolGardensBlock">
      <div :class="$style.image">
        <img
          src="/images/work/img-model_cities.jpg"
          :alt="$t('solutionSection.modelCities.title')"
        />
      </div>
      <div :class="$style.featureText">
        <div :class="$style.subtitle">
          {{ $t("solutionSection.modelCities.title") }}
        </div>
        <div :class="$style.text">
          <p>{{ $t("solutionSection.modelCities.text") }}</p>
        </div>
        <button :class="$style.button" @click="openModelCitiesPage">
          {{ $t("solutionSection.modelCities.learnMore") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Applicate from "./Applicate.vue";
import SchoolGardensSlider from "./SchoolGardensSlider.vue";
export default {
  components: {
    Applicate,
    SchoolGardensSlider,
  },
  data() {
    return {
      schoolGardenImages: [
        "/img-slider/school-garden-1.jpeg",
        "/img-slider/school-garden-2.jpeg",
        "/img-slider/school-garden-3.jpeg",
        "/img-slider/school-garden-4.jpeg",
      ],
    };
  },
  methods: {
    openSchoolGardensPage() {
      window.location.hash = "#/school-gardens";
    },
    openEducationalPartnersPage() {
      window.location.hash = "#/educational-partners";
    },
    openModelCitiesPage() {
      window.location.hash = "#/model-cities";
    },
  },
};
</script>

<style lang="scss" module>
.container {
  @include container;
  @include custom(720) {
    margin-bottom: 4rem;
  }
  .title {
    @include F64-600;
    font-size: 3rem;
    line-height: 1.15;
    margin: 0 0 2rem 0;
    text-align: left;
    @include custom(1050) {
      margin: 0 0 3rem 0;
    }
    @include custom(830) {
      font-size: 2.5rem;
      line-height: 1.1;
    }
    @include mobile {
      font-size: 2.25rem;
    }
  }
  .description {
    @include F28-400;
    font-size: 1.5rem;
    line-height: 1.5;
    max-width: 70rem;
    margin: 0 0 6.25rem 0;
    text-align: left;
    @include custom(1050) {
      margin-bottom: 3rem;
      line-height: 1.4;
    }
    @include custom(530) {
      font-size: 1.1rem;
    }
  }
  .schoolGardensBlock {
    display: grid;
    grid-template-columns: minmax(16rem, 0.75fr) minmax(0, 1fr);
    align-items: center;
    gap: 3rem;
    margin: 0 0 4.5rem 0;
    @include custom(1050) {
      gap: 2rem;
      margin-bottom: 3.5rem;
    }
    @include custom(760) {
      grid-template-columns: 1fr;
      gap: 2rem;
    }
    &.reverse {
      grid-template-columns: minmax(0, 1fr) minmax(16rem, 0.75fr);
      @include custom(760) {
        grid-template-columns: 1fr;
      }
    }
    &.reverse .image {
      @include custom(760) {
        order: 1;
      }
    }
    &.reverse .featureText {
      @include custom(760) {
        order: 2;
      }
    }
    .gallery {
      width: 100%;
      max-width: 29rem;
      margin: 0 auto;
      @include custom(760) {
        max-width: 24rem;
      }
    }
    .applicate {
      grid-column: 1 / -1;
      width: 100%;
    }
    .image {
      width: 100%;
      max-width: 29rem;
      margin: 0 auto;
      @include custom(760) {
        max-width: 24rem;
      }
      & img {
        width: 100%;
        aspect-ratio: 1 / 1;
        object-fit: cover;
        display: block;
        border-radius: 0.625rem;
      }
    }
    .featureText {
      .subtitle {
        @include F36-600;
        font-size: 1.75rem;
        line-height: 1.35;
        margin: 0 0 1.5rem 0;
        @include custom(1200) {
          margin: 0 0 1rem 0;
        }
        @include custom(450) {
          font-size: 1.5rem;
          line-height: 100%;
          margin: 0 0 1rem 0;
        }
      }
      .text {
        @include F28-400;
        font-size: 1.5rem;
        line-height: 1.5;
        margin-bottom: 1.5rem;
        @include custom(1200) {
          line-height: 1.4;
        }
        @include custom(530) {
          font-size: 1.1rem;
        }
        & p {
          margin: 0 0 1.5rem 0;
          &:last-child {
            margin: 0;
          }
        }
      }
      .button {
        @include F28-600;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 1rem 2rem;
        border: 0.3125rem solid $orange;
        border-radius: 0.625rem;
        background-color: $white;
        color: $black;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        &:hover {
          background-color: $orange;
          color: $white;
        }
        @include custom(530) {
          width: 100%;
          font-size: 1.25rem;
        }
      }
    }
  }
}
</style>
